export enum ChitState {
  Assigned = 0,
  Submitted = 1,
  Approved = 2
}

export enum ChitType {
  AlarmResponse = 0,
  InteriorCheckWithKey = 1,
  IBM = 2,
  Lock = 3,
  PatrolCheck = 4,
  ExteriorCheckOnly = 5,
  VagrantRemoval = 6,
  Unlock = 7
}

export enum ChitOptionType {
  Observation = 'observation',
  Condition = 'condition',
  Type = 'type'
}

export enum ChitOptionConstraintType {
  Optional,
  Required,
  Hidden
}
